var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPadlockIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00332 1.71429C4.05655 1.71429 3.28904 2.4818 3.28904 3.42857V4.28571H6.71761V3.42857C6.71761 2.4818 5.9501 1.71429 5.00332 1.71429ZM1.57475 3.42857V4.28571C0.864685 4.28573 0.289062 4.86135 0.289062 5.57143V10.7143C0.289062 11.4243 0.864694 12 1.57478 12H8.43189C9.14204 12 9.71761 11.4243 9.71761 10.7143V5.57143C9.71761 4.86135 9.14204 4.28571 8.43189 4.28571V3.42857C8.43189 1.53502 6.89687 0 5.00332 0C3.10977 0 1.57475 1.53502 1.57475 3.42857ZM5.00335 9.21429C5.59509 9.21429 6.07478 8.73463 6.07478 8.14286C6.07478 7.55112 5.59509 7.07143 5.00335 7.07143C4.41161 7.07143 3.93192 7.55112 3.93192 8.14286C3.93192 8.73463 4.41161 9.21429 5.00335 9.21429Z",
    fill: "#9EA3AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockIconGrey);
export default __webpack_public_path__ + "static/media/padlockIconGrey.923683bbfb80930357772842d617408e.svg";
export { ForwardRef as ReactComponent };